<template>
  <PageTitle :title="content.mediaAndArchive" :parentTitle="content.home">
    <div class="flex items-center">
      <div class="
          bg-primary
          relative
          
          h-16
          lg:min-w-[160px]
          ltr:mr-4
          rtl:ml-4
          min-w-[140px]
          px-4
          flex
          items-center
          justify-between
          cursor-pointer
        " @click="openFilter = !openFilter">
        <div class="capitalize text-sm sm:text-base ltr:mr-2 rtl:ml-2">
          {{ content[$route.query.type] }}
        </div>
        <div>
          <i class="fa fa-chevron-down transition-all duration-300" :class="{ 'rotate-180': openFilter }"></i>
        </div>
        <div class="
            max-h-0
            
            overflow-hidden
            lg:min-w-[160px]
            min-w-[140px]
            transition-all
            duration-300
            absolute
            left-0
            top-[74px]
            z-[1]
            bg-primary
          " :class="{ openWorksFilter: openFilter }">
          <!-- <router-link to="/archive?type=all">
            <div v-if="$route.query.type != 'all'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.all }}
            </div>
          </router-link> -->
          <router-link to="/videos">
            <div v-if="$route.query.type != 'videos'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.videos }}
            </div>
          </router-link>
          <router-link to="/archive?type=writings">
            <div v-if="$route.query.type != 'writings'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.writings }}
            </div>
          </router-link>
          <router-link to="/archive?type=books">
            <div v-if="$route.query.type != 'books'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.books }}
            </div>
          </router-link>
        </div>
      </div>
      <YearDropdown @setYear="setYear"></YearDropdown>
    </div>
  </PageTitle>
  <div v-if="noResults" class="font-xl layout-padding ">{{ content.noResultFound }}</div>
  <ItemsSkeleton v-else-if="archives.length == 0" />
  <div v-else class="grid grid-cols-6 layout-padding lg:gap-24 md:gap-12 gap-0 mt-8 mb-16">
    <div class="col-span-6 md:col-span-3 lg:col-span-2 mb-5 md:mb-0" v-for="(archive, index) in archives" :key="index"
      :class="
        index % 2 == 0
          ? `lg:mt-14  animate-archive-${index}`
          : ` lg:mt-5 animate-archive-odd-${index}`
      ">
      <ArchiveCard :archive="archive" />
    </div>
    <div class="col-span-6 flex justify-center my-8">
      <div @click="loadData" v-if="!allArchivesLoaded" class="
          py-4
          px-10
          bg-primary
          text-center
          transition-all
          duration-700
          hover:bg-secondary
          cursor-pointer
          min-w-[216px]
        ">
        {{ content.loadMore }}
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import ArchiveCard from "/src/components/UI/Cards/ArchiveCard.vue";

export default {
  inject: ["content"],
  data() {
    return {
      openFilter: false,
      selectedYear: null,
      oldLength: 0,
    };
  },
  computed: {
    archives() {
      return this.$store.getters["archive/archive"];
    },
    noResults() {
      return this.$store.getters["archive/noResult"];
    },
    allArchivesLoaded() {
      return this.$store.getters["archive/allArchivesLoaded"];
    },
  },
  components: {
    ArchiveCard,
  },
  methods: {
    async loadData() {
      if (this.$route.query.type != "all") {
        this.oldLength = this.archives.length;
        await this.$store.dispatch("archive/filterArchive", {
          type: this.$route.query.type,
          year: this.selectedYear == null ? "all" : this.selectedYear,
        });
        await this.animate();
      } else {
        this.oldLength = this.archives.length;

        await this.$store.dispatch("archive/filterArchive", {
          type: "all",
          year: this.selectedYear == null ? "all" : this.selectedYear,
        });
        await this.animate();
      }
    },
    setYear(year) {
      this.selectedYear = year;
    },
    animate() {
      if (screen.width > 1024 || screen.width < 768) {
        for (let s = this.oldLength; s < this.archives.length; s++) {
          // if (s % 2 == 0) {
          gsap.to(`.animate-archive-${s}`, {
            y: "-30%",
            scrollTrigger: {
              trigger: `.animate-archive-${s}`,
              start: "top 200",
              end: "500",
              scrub: 1,
            },
          });
          // } else {
          gsap.to(`.animate-archive-odd-${s}`, {
            y: "-15%",
            scrollTrigger: {
              trigger: `.animate-archive-odd-${s}`,
              start: "top top",
              end: "500",
              scrub: 1,
            },
          });
          // }
        }
      } else {
        for (let s = this.oldLength; s < this.archives.length; s++) {
          gsap.to(`.animate-archive-${s}`, {
            y: "-15%",
            scrollTrigger: {
              trigger: `.animate-archive-${s}`,
              start: "top 200",
              end: "500",
              scrub: 1,
            },
          });
          gsap.to(`.animate-archive-odd-${s}`, {
            y: "-15%",
            scrollTrigger: {
              trigger: `.animate-archive-odd-${s}`,
              start: "top 200",
              end: "500",
              scrub: 1,
            },
          });
        }
      }
    },
  },
  watch: {
    "$route.query.type": {
      handler: function () {
        this.$store.dispatch("archive/resetArchive");
        this.oldLength = 0;
        this.loadData();
      },
      deep: true,
      immediate: true,
    },
    selectedYear() {
      this.$store.dispatch("archive/resetArchive");
      this.loadData();
    },
  },
};
</script>